import React from 'react'
import MVComponent from '../../Component/Missionvission/Mission'
import {
  Grid,
  Container,
  Divider,
  useMediaQuery,
  useTheme,
  Box,
} from '@mui/material'

const MissionVission = ({ MV_DATA }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'))

  // Check if MV_DATA is an array with content_type
  if (Array.isArray(MV_DATA) && MV_DATA.some((item) => item.content_type)) {
    // Filter mission and vision data
    const visionData = MV_DATA?.find((item) => item.content_type === 'Vision')
    const missionData = MV_DATA?.find((item) => item.content_type === 'Mission')

    return (
      <Box
        component="section"
        sx={{
          my: isMobile ? 3 : 5,
          py: isMobile ? 2 : 0,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={isMobile ? 2 : 4}>
            {visionData && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  minHeight: isMobile ? 'auto' : '400px',
                  borderRight: isMobile
                    ? 'none'
                    : `1px solid ${theme.palette.divider}`,
                  pr: isMobile ? 0 : 4,
                  mb: isMobile ? 3 : 0,
                }}
              >
                <MVComponent getdata={visionData} />
              </Grid>
            )}

            {isMobile && visionData && missionData && (
              <Divider
                sx={{
                  width: '100%',
                  my: 2,
                  borderColor: theme.palette.divider,
                }}
              />
            )}

            {missionData && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  minHeight: isMobile ? 'auto' : '400px',
                  pl: isMobile ? 0 : 4,
                }}
              >
                <MVComponent getdata={missionData} />
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    )
  } else {
    // Render as usual if MV_DATA does not contain content_type
    return (
      <Box
        component="section"
        sx={{
          my: isMobile ? 3 : 5,
          py: isMobile ? 2 : 0,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={isMobile ? 2 : 4}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                minHeight: isMobile ? 'auto' : '400px',
                borderRight: isMobile
                  ? 'none'
                  : `3px solid ${theme.palette.divider}`,
                pr: isMobile ? 0 : 4,
                mb: isMobile ? 3 : 0,
              }}
            >
              {MV_DATA?.Vission && <MVComponent getdata={MV_DATA?.Vission} />}
            </Grid>

            {isMobile && MV_DATA?.Vission && MV_DATA?.Mission && (
              <Divider
                sx={{
                  width: '100%',
                  my: 5,
                  borderColor: theme.palette.divider,
                }}
              />
            )}

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                minHeight: isMobile ? 'auto' : '400px',
                pl: isMobile ? 0 : 4,
              }}
            >
              {MV_DATA?.Mission && <MVComponent getdata={MV_DATA?.Mission} />}
            </Grid>
          </Grid>
        </Container>
      </Box>
    )
  }
}

export default MissionVission
